import { createSelector } from '@reduxjs/toolkit';
import { selectNewbuildingSaleTypeValue } from './selectNewbuildingSaleTypeValue';
import { FLAT_NEW_LIST } from './constants';

export const selectNewbuildingSaleTypeFilter = createSelector(selectNewbuildingSaleTypeValue, value => ({
  label: 'В новостройках',
  value,
  options: FLAT_NEW_LIST,
}));
